// extracted by mini-css-extract-plugin
module.exports = {"root":"media_root__3SLde","logos":"media_logos__3qGDe","Breakit":"media_Breakit__1ZxvE","NyTeknik":"media_NyTeknik__1IwXo","dot":"media_dot__3pfO_","larger":"media_larger__1Je8p"};